import { useEffect } from "react";
import { Printer, DownloadSimple } from "@phosphor-icons/react";

export default function Autorisation() {
  useEffect(() => {
    document.title = "Autorisation parentale — Urban Fest 2026";
  }, []);

  const print = () => window.print();

  return (
    <div data-testid="autorisation-page">
      {/* HEADER ACTIONS (hidden when printing) */}
      <div className="no-print max-w-4xl mx-auto px-4 sm:px-8 pt-12">
        <p className="text-xs tracking-[0.3em] uppercase text-[#FF6B1A] mb-4">Mineurs</p>
        <h1 className="font-display text-4xl sm:text-6xl leading-none mb-4">AUTORISATION PARENTALE</h1>
        <p className="text-white/60 text-lg max-w-2xl mb-8">
          Pour participer à Urban Fest 2026, tout joueur mineur doit présenter une autorisation parentale signée par
          son représentant légal. Télécharge ou imprime le formulaire, fais-le signer, et apporte-le le jour du tournoi.
        </p>

        <div className="flex gap-3 flex-wrap mb-12">
          <button onClick={print} className="btn-brutal" data-testid="print-btn">
            <Printer size={18} weight="bold" /> Imprimer / Télécharger en PDF
          </button>
          <a
            href="#form"
            className="btn-brutal btn-brutal-ghost"
            data-testid="preview-btn"
          >
            <DownloadSimple size={18} weight="bold" /> Aperçu du formulaire
          </a>
        </div>

        <div className="uf-card p-6 mb-10 border-l-4 border-l-[#FF6B1A]">
          <p className="text-sm tracking-[0.2em] uppercase font-bold text-[#FF6B1A] mb-2">Comment faire</p>
          <ol className="text-white/80 text-sm space-y-1 list-decimal list-inside">
            <li>Clique sur <strong>"Imprimer / Télécharger en PDF"</strong> ci-dessus.</li>
            <li>Dans la boîte d'impression : choisis <strong>"Enregistrer en PDF"</strong> comme imprimante (ou imprime sur papier).</li>
            <li>Fais signer le formulaire par le parent/représentant légal.</li>
            <li>Apporte le formulaire signé <strong>le jour du tournoi</strong> (29 août 2026) au check-in.</li>
          </ol>
        </div>
      </div>

      {/* FORM PRINTABLE PAGE */}
      <div id="form" className="printable-form" data-testid="autorisation-form">
        <div className="form-header">
          <div className="form-header-bar"></div>
          <div className="form-titles">
            <h2>AUTORISATION PARENTALE</h2>
            <p className="form-sub">Urban Fest 2026 — Tournoi inter-quartiers</p>
            <p className="form-meta">29 & 30 Août 2026 · Quartier Jean-Yole · La Roche-sur-Yon</p>
            <p className="form-meta">Organisé par <strong>Action Impact Jeunesse</strong></p>
          </div>
        </div>

        <section className="form-section">
          <h3>1 · Représentant légal</h3>
          <div className="row">
            <label>Nom :</label>
            <span className="line"></span>
          </div>
          <div className="row">
            <label>Prénom :</label>
            <span className="line"></span>
          </div>
          <div className="row">
            <label>Lien de parenté :</label>
            <span className="checkboxes">
              <span className="cb">☐ Père</span>
              <span className="cb">☐ Mère</span>
              <span className="cb">☐ Tuteur légal</span>
              <span className="cb">☐ Autre :</span>
              <span className="line short"></span>
            </span>
          </div>
          <div className="row">
            <label>Adresse :</label>
            <span className="line"></span>
          </div>
          <div className="row split">
            <span>
              <label>Code postal :</label>
              <span className="line short"></span>
            </span>
            <span>
              <label>Ville :</label>
              <span className="line short"></span>
            </span>
          </div>
          <div className="row split">
            <span>
              <label>Téléphone :</label>
              <span className="line short"></span>
            </span>
            <span>
              <label>Email :</label>
              <span className="line short"></span>
            </span>
          </div>
        </section>

        <section className="form-section">
          <h3>2 · Mineur participant</h3>
          <div className="row split">
            <span>
              <label>Nom :</label>
              <span className="line short"></span>
            </span>
            <span>
              <label>Prénom :</label>
              <span className="line short"></span>
            </span>
          </div>
          <div className="row split">
            <span>
              <label>Date de naissance :</label>
              <span className="line short"></span>
            </span>
            <span>
              <label>Âge :</label>
              <span className="line tiny"></span>
              <label>&nbsp;ans</label>
            </span>
          </div>
          <div className="row">
            <label>Équipe / Quartier :</label>
            <span className="line"></span>
          </div>
          <div className="row">
            <label>Discipline :</label>
            <span className="checkboxes">
              <span className="cb">☐ Basket 3v3</span>
              <span className="cb">☐ Football 5v5</span>
            </span>
          </div>
        </section>

        <section className="form-section">
          <h3>3 · Personne à prévenir en cas d'urgence</h3>
          <div className="row split">
            <span>
              <label>Nom / Prénom :</label>
              <span className="line short"></span>
            </span>
            <span>
              <label>Téléphone :</label>
              <span className="line short"></span>
            </span>
          </div>
          <div className="row">
            <label>Informations médicales utiles (allergies, traitements, asthme…) :</label>
          </div>
          <div className="line full"></div>
          <div className="line full"></div>
        </section>

        <section className="form-section">
          <h3>4 · Autorisation</h3>
          <p className="legal">
            Je soussigné(e) <span className="line inline"></span>, agissant en qualité de représentant légal,
            <strong> autorise mon enfant</strong> dont les coordonnées sont indiquées ci-dessus à participer au
            tournoi <strong>Urban Fest 2026</strong> qui se déroulera les <strong>29 et 30 août 2026</strong> au
            Quartier Jean-Yole à La Roche-sur-Yon, organisé par l'association <strong>Action Impact Jeunesse</strong>.
          </p>
          <p className="legal">
            J'autorise les organisateurs à prendre toutes les mesures nécessaires en cas d'urgence médicale (appel
            des secours, transport à l'hôpital, intervention médicale ou chirurgicale d'urgence).
          </p>
          <p className="legal">
            Je reconnais que mon enfant est <strong>responsable de ses affaires personnelles</strong> et que les
            organisateurs déclinent toute responsabilité en cas de perte ou vol.
          </p>
          <p className="legal">
            Je certifie que mon enfant est <strong>physiquement apte</strong> à la pratique du sport concerné.
          </p>
        </section>

        <section className="form-section">
          <h3>5 · Droit à l'image</h3>
          <div className="row">
            <span className="cb big">☐ J'autorise</span>
            <span className="cb big">☐ Je n'autorise pas</span>
          </div>
          <p className="legal small">
            l'association Action Impact Jeunesse à diffuser des photos et vidéos sur lesquelles mon enfant apparaît,
            prises lors de l'événement Urban Fest 2026, sur le site web (urbanfest85.com), les réseaux sociaux
            (Instagram @action.impact.jeunesse) et les supports de communication de l'association.
          </p>
        </section>

        <section className="form-section signature-section">
          <div className="signature-row">
            <div className="signature-box">
              <p className="sig-label">Fait à :</p>
              <span className="line short"></span>
              <p className="sig-label">Le :</p>
              <span className="line short"></span>
            </div>
            <div className="signature-box">
              <p className="sig-label">Signature du représentant légal</p>
              <p className="sig-mention">(précédée de la mention « Lu et approuvé »)</p>
              <div className="signature-area"></div>
            </div>
          </div>
        </section>

        <footer className="form-footer">
          <p><strong>Action Impact Jeunesse</strong> · 06 95 62 29 53 · actionimpactjeunesse@gmail.com</p>
          <p>actionimpactjeunesse.com · @action.impact.jeunesse · Urban Fest 2026</p>
        </footer>
      </div>

      <style>{`
        .printable-form {
          background: #ffffff;
          color: #111;
          max-width: 800px;
          margin: 0 auto 60px;
          padding: 40px 50px;
          font-family: 'Outfit', sans-serif;
          font-size: 13.5px;
          line-height: 1.5;
          box-shadow: 0 0 60px rgba(255,107,26,0.15);
          border-radius: 6px;
        }
        .printable-form h2 {
          font-family: 'Anton', sans-serif;
          font-size: 30px;
          margin: 0;
          letter-spacing: 0.04em;
          color: #1a1a1a;
        }
        .printable-form h3 {
          font-family: 'Anton', sans-serif;
          font-size: 16px;
          letter-spacing: 0.08em;
          background: #FF6B1A;
          color: #fff;
          padding: 6px 12px;
          margin: 18px 0 14px;
          display: inline-block;
        }
        .form-header {
          display: flex;
          gap: 14px;
          align-items: stretch;
          border-bottom: 3px solid #FF6B1A;
          padding-bottom: 14px;
          margin-bottom: 22px;
        }
        .form-header-bar { width: 8px; background: linear-gradient(180deg,#FFC32E,#FF6B1A,#E63946); }
        .form-sub { color: #FF6B1A; font-weight: 700; margin: 4px 0 2px; font-size: 14px; }
        .form-meta { margin: 0; font-size: 11.5px; color: #555; }
        .form-section { margin-bottom: 14px; }
        .row { margin: 6px 0; display: flex; align-items: baseline; gap: 8px; flex-wrap: wrap; }
        .row.split { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
        .row.split > span { display: flex; align-items: baseline; gap: 6px; }
        label { font-weight: 600; color: #333; font-size: 12.5px; }
        .line { flex: 1; border-bottom: 1px solid #444; height: 16px; min-width: 80px; }
        .line.short { min-width: 100px; }
        .line.tiny { min-width: 30px; max-width: 40px; flex: 0 0 40px; }
        .line.inline { display: inline-block; width: 180px; vertical-align: bottom; border-bottom: 1px solid #444; height: 14px; }
        .line.full { border-bottom: 1px solid #444; height: 16px; margin: 4px 0; }
        .checkboxes { display: flex; gap: 14px; align-items: baseline; flex-wrap: wrap; flex: 1; }
        .cb { font-size: 12.5px; }
        .cb.big { font-size: 14px; font-weight: 600; }
        .legal { font-size: 12px; color: #222; margin: 6px 0; text-align: justify; }
        .legal.small { font-size: 11.5px; color: #444; }
        .signature-section { margin-top: 22px; border-top: 2px dashed #FF6B1A; padding-top: 16px; }
        .signature-row { display: grid; grid-template-columns: 1fr 1.3fr; gap: 24px; }
        .signature-box { border: 1px solid #ddd; padding: 12px; border-radius: 4px; }
        .sig-label { font-weight: 600; font-size: 12px; margin: 8px 0 4px; }
        .sig-mention { font-size: 10.5px; color: #777; font-style: italic; margin: 0 0 8px; }
        .signature-area { height: 80px; border: 1px dashed #aaa; border-radius: 3px; }
        .form-footer {
          border-top: 1px solid #ddd;
          margin-top: 26px;
          padding-top: 10px;
          text-align: center;
          font-size: 10.5px;
          color: #555;
        }
        .form-footer p { margin: 2px 0; }

        @media print {
          @page { size: A4; margin: 12mm; }
          html, body { background: #fff !important; color: #000 !important; }
          .no-print, header[data-testid="site-header"], footer[data-testid="site-footer"],
          [data-testid="replay-teaser-btn"] { display: none !important; }
          .printable-form {
            box-shadow: none !important;
            margin: 0 !important;
            padding: 0 !important;
            max-width: 100% !important;
          }
          .App { background: #fff !important; }
        }
      `}</style>
    </div>
  );
}
